import React from 'react';
import {useNavigate, useParams} from 'react-router';
import useReadbookItems from '../../hooks/useReadbookItems';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import {Box, Divider, Stack} from "@mui/material";
import ReadbookItemStack from '../../components/ReadbookItemStack';

const ReadbookItems = () => {
    const {readbookId, sourceSegmentId} = useParams();
    const navigate = useNavigate();
    const {items, loading, error} = useReadbookItems(readbookId);

    if (loading) return <div style={{padding: 16}}><CircularProgress size={24}/> <span style={{marginLeft: 8}}>Loading items...</span>
    </div>;
    if (error) return <div style={{padding: 16}}>Error loading items: {String(error.message || error)}</div>;

    const onClickItem = (item) => {
        // navigate to readbook item page by id (adjust route as needed)
        navigate(item.reportId);
    };

    // Helper to normalize published into a date-string key (YYYY-MM-DD) when possible,
    // otherwise use the raw string or 'unknown'.
    const publishedKey = (published) => {
        if (!published) return 'unknown';
        if (typeof published === 'string') return published;
        try {
            const d = new Date(published);
            if (isNaN(d.getTime())) return String(published);
            return d.toISOString().split('T')[0];
        } catch (e) {
            return String(published);
        }
    };

    // Group items by published key
    const groups = items.reduce((acc, it) => {
        const key = publishedKey(it.published);
        if (!acc[key]) acc[key] = [];
        acc[key].push(it);
        return acc;
    }, {});

    return (
        <Stack spacing={2} pb={4}>
            {items.length === 0 ? (
                <Typography variant="body2" mb={1} p={2}>No items found</Typography>
            ) : (
                // Render groups sorted by published key descending (newest first)
                Object.keys(groups)
                    .sort((a, b) => (a < b ? 1 : -1))
                    .map((key) => (
                        <Box key={key}>
                            <Typography variant="subtitle1" p={2} pb={0}>{key}</Typography>
                            <Stack>
                                {groups[key].map(item => (
                                    <ReadbookItemStack
                                        key={item.id} item={item} onClick={() => onClickItem(item)}
                                        activeItemId={sourceSegmentId}
                                    />
                                ))}
                            </Stack>
                            <Divider sx={{mt: 1}}/>
                        </Box>
                    ))
            )}
        </Stack>
    );
};

export default ReadbookItems;
